import { connect } from 'react-redux';
import StartCallModal from 'components/StartCallModal/StartCallModal';
import actions from 'actions/StartCallModal';
import { START_CALL_FORM } from 'constants/StartCallModal';
import contactActions from 'actions/Contact';
import avActions from 'actions/AvSettingsModal';
import settingsActions from 'actions/SettingsModal';
import { cancelJoinCall } from 'actions/JoinModal';
import { reset } from 'redux-form';
import { searchSelectors, mediaSelectors, streamActions } from '@lifesize/nucleus';
import _get from 'lodash/get';
import selectors from 'selectors/startCallModal';

const mapStateToProps = (state) => {
  const contact = selectors.getStartCallModalContact(state);
  const searchString = _get(state, 'app.form.startCallSearch.values.startCallSearch');
  const searchResults = searchSelectors.searchContacts(state);
  const manualDial = !searchResults.length && !!searchString;
  const rememberSettings = _get(state, 'app.avSettings.rememberSettings');
  const callOneTime = _get(state, 'app.startCallModal.callOneTime');

  const preserveSettings = _get(state, 'app.avSettings.preserveAvSettings');
  const defaultAudioSetting = preserveSettings ?
    _get(state, 'app.avSettings.audio') : _get(state, 'app.settingsModal.defaultAudioSetting');
  const primaryVideoSourceId = _get(state, 'app.avSettings.videoSourceId') || _get(mediaSelectors.selectedVideoDevice(state), 'deviceId') || -1;
  const primaryAudioSourceId = _get(state, 'app.avSettings.audioSourceId') || _get(mediaSelectors.selectedAudioDevice(state), 'deviceId') || -1;
  const primaryAudioOutputId = _get(state, 'app.avSettings.audioOutputId') || _get(mediaSelectors.selectedAudioOutputDevice(state), 'deviceId') || -1;

  const selectedSources = {
    primaryVideoSourceId,
    primaryAudioSourceId,
    primaryAudioOutputId
  };


  return {
    contact,
    manualDial,
    searchString,
    selectedSources,
    defaultAudioSetting,
    rememberSettings,
    callOneTime
  };
};

const mapDispatchToProps = dispatch => ({
  clearSelectedCall: () => {
    dispatch(reset(START_CALL_FORM));
    dispatch(actions.selectContactForCall(null));
    dispatch(avActions.resetCallSettings());
    dispatch(cancelJoinCall());
  },
  handleAudioCall: (contact, media) => {
    dispatch(contactActions.startAudioCall(contact, media));
  },
  handleVideoCall: (contact, media) => {
    dispatch(contactActions.startVideoCall(contact, media));
  },
  saveCallSettings: (selectedSources, defaultAudioSetting) => {
    if (selectedSources.primaryVideoSourceId !== -1) {
      dispatch(streamActions.setPrimaryVideoSourceId(selectedSources.primaryVideoSourceId));
    }
    if (selectedSources.primaryAudioSourceId !== -1) {
      dispatch(streamActions.setPrimaryAudioSourceId(selectedSources.primaryAudioSourceId));
    }
    if (selectedSources.primaryAudioOutputId !== -1) {
      dispatch(streamActions.setPrimaryAudioOutputId(selectedSources.primaryAudioOutputId));
    }

    dispatch(settingsActions.saveAudioMuted(defaultAudioSetting));
  }
});

const mergeProps = (stateProps, dispatchProps, ownProps) => (
  Object.assign({}, ownProps, stateProps, dispatchProps,
    {
      handleAudioCall: () => {
        if (stateProps.rememberSettings) {
          dispatchProps.saveCallSettings(
            stateProps.selectedSources, stateProps.defaultAudioSetting
          );
        }
        const media = Object.assign(
          {},
          stateProps.selectedSources,
          { video: false, audio: stateProps.defaultAudioSetting });
        return (dispatchProps.handleAudioCall(stateProps.contact, media));
      },
      handleVideoCall: () => {
        if (stateProps.rememberSettings) {
          dispatchProps.saveCallSettings(
            stateProps.selectedSources, stateProps.defaultAudioSetting
          );
        }
        const media = Object.assign(
          {},
          stateProps.selectedSources,
          { video: true, audio: stateProps.defaultAudioSetting });
        return (dispatchProps.handleVideoCall(stateProps.contact, media));
      }
    })
);

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(StartCallModal);
